import { PremiumLabel, Typography } from '@lacedltd/laced-components'
import * as React from 'react'
import { useEstimatedDeliveryDate, useTranslation } from 'hooks'
import { withTranslations } from 'helpers'
import PremiumDeliveryCountdown from '../../shared/PremiumDeliveryCountdown'
import * as S from './PremiumCartFlag.styles'

const PremiumCartFlag = ({ groupType }: { groupType: string }) => {
  const { t } = useTranslation()
  const { error, remainingTime } = useEstimatedDeliveryDate()

  if (!remainingTime || error) return null

  return (
    <S.PremiumCartDeliveryWrap data-testid="cart-delivery-label">
      <PremiumLabel value={t('shared.premium.title')} />
      <Typography.Text variant="caption" color="airJordan.p">
        <PremiumDeliveryCountdown type="long" groupType={groupType} />
      </Typography.Text>
    </S.PremiumCartDeliveryWrap>
  )
}

export default withTranslations(PremiumCartFlag)
